module.exports = __webpack_public_path__ + "static/img/5.fc710d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/eng/5.png
// module id = oean
// module chunks = 0